import { BKOUSERS_API_BASE_ROUTE } from 'settings/api-settings';
import { getAccessToken } from 'utils/utils';
import { authFetch } from "api";


export const getBkoUsers = async () => {
  //const at = await getAccessToken()

  const response = await authFetch(BKOUSERS_API_BASE_ROUTE);

  if(response.ok) {
    const bkoUsers = await response.json();
    return bkoUsers.map((bkoUser) => ({
      ...bkoUser,
      createdDate: new Date(bkoUser.createdDate),
      modifiedDate: bkoUser.modifiedDate && new Date(bkoUser.modifiedDate),
    }));
  }
  else if(response.status === 401) {
    throw Error('REDIRECT_TO_LOGIN');
  }
  else if(response.status >= 500) {
    throw Error('Something went wrong loading the bkoUsers.');
  }
};
/*
export const getBkoUser = async (adminId) => {
  const url = BKOUSERS_API_BASE_ROUTE + '/' + adminId;
  const response = await authFetch(url);
  const bkoUser = await response.json();
  return bkoUser;
};
*/
export const createBkoUser = async (bkoUserCreateData) => {
  // await new Promise(res => setTimeout(res, 20000));
  const response = await authFetch(BKOUSERS_API_BASE_ROUTE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bkoUserCreateData),
  });
  if (response.status === 201) {
    return await response.json();
  }
  throw `Unhandled status code ${response.status} for createBkoUser`;
};

export const updateBkoUser = async (adminId, bkoUserEditData) => {
  const url = BKOUSERS_API_BASE_ROUTE + '/' + adminId;
  const response = await authFetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bkoUserEditData),
  });
};
